import React, { useState } from "react";
import { useApp } from "context";
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Grid, Typography } from "@mui/material";
import { Card, Custom, Modal } from "components";
import { Helpers } from "utils";
import { IAppointment } from "interfaces";

ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend
);

type Props = {};

export const Home = (props: Props) => {
  const { t, theme, user } = useApp();

  const [announcementOpened, setAnnouncementOpened] = useState(false);
  const [announcementMakeOpened, setAnnouncementMakeOpened] = useState(false);
  const [reminderOpened, setReminderOpened] = useState(false);
  const [clinicOpened, setClinicOpened] = useState(false);

  const [bigCalendarOpened, setBigCalendarOpened] = useState(true);
  const [health360Opened, setHealth360Opened] = useState(false);
  const [qarePlpanOpened, setQarePlanOpened] = useState(false);
  const [patientOpened, setPatientOpened] = useState(false);

  const [selectedHealth360s, setSelectedHealth360s] = useState<IAppointment[]>(
    []
  );

  // TODO: it may be improved (currently being used to force the updated of the appointments)
  const [incrementComponentAnnouncement, setIncrementComponentAnnouncement] =
    useState(0);
  const [incrementComponentReminder, setIncrementComponentReminder] =
    useState(0);

  const handleAnnouncementOpen = () => setAnnouncementOpened(true);
  const handleAnnouncementClose = () => setAnnouncementOpened(false);

  const handleMakeAnnouncementOpen = () => setAnnouncementMakeOpened(true);
  const handleMakeAnnouncementClose = () => {
    setIncrementComponentAnnouncement(incrementComponentAnnouncement + 1);
    setAnnouncementMakeOpened(false);
  };

  const handleReminderOpen = () => setReminderOpened(true);
  const handleReminderClose = () => setReminderOpened(false);

  const handleClinicOpen = () => setClinicOpened(true);
  const handleClinicClose = () => setClinicOpened(false);

  const handleCreateReminderClose = () =>
    setIncrementComponentReminder(incrementComponentReminder + 1);

  // TODO: announcement and reminder cards are removed and style is messy

  return (
    <>
      <div className="qh-header">
        <Grid container spacing={theme.margin.md}>
          <Grid container item xs={12} sm={6}>
            <div className="qh-title">
              <Typography
                component="span"
                sx={{ fontSize: theme.font.md, marginRight: theme.margin.sm }}
              >
                {Helpers.interpolate(t.message.greeting[Helpers.greeting()], {
                  username: user.username,
                })}
              </Typography>
            </div>
          </Grid>
          <Grid container item xs={12} sm={6} justifyContent="flex-end">
            <div className="qh-control">
              <Custom.Button onClick={handleMakeAnnouncementOpen}>
                {t.action.make_announcement}
              </Custom.Button>
              <Modal.MakeAnnouncement
                opened={announcementMakeOpened}
                onClose={handleMakeAnnouncementClose}
              />
            </div>
          </Grid>
        </Grid>
      </div>
      <div className="qh-content">
        <Grid container spacing={theme.margin.md}>
          <Grid item xs={12} sm={8} md={8}>
            {/* <Card.LineChartButtons /> */}
            <Card.BigCalendar
              opened={bigCalendarOpened}
              toggle={() => setBigCalendarOpened(!bigCalendarOpened)}
              selectedHealth360={
                selectedHealth360s.length === 1 &&
                selectedHealth360s[0].providerId !== null
                  ? selectedHealth360s[0]
                  : null
              }
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Grid container spacing={theme.margin.md}>
              <Grid item md={12}>
                <Card.AppointmentStats />
                {/* </Grid> */}
                {/* <Grid item xs={12} sm={6} md={4}>
            <Card.Announcement
              opened={announcementOpened}
              onOpen={handleAnnouncementOpen}
              onClose={handleAnnouncementClose}
              incrementComponent={incrementComponentAnnouncement}
            />
          </Grid> */}
                {/* <Grid item xs={12} sm={8} md={4}> */}
              </Grid>
              <Grid item md={12}>
                <Card.Clinic
                  opened={clinicOpened}
                  onOpen={handleClinicOpen}
                  onClose={handleClinicClose}
                />
              </Grid>
            </Grid>
          </Grid>
          {/* <Grid item xs={12} sm={6} md={4}>
            <Card.Reminder
              opened={reminderOpened}
              onOpen={handleReminderOpen}
              onClose={handleReminderClose}
              incrementComponent={incrementComponentReminder}
            />
          </Grid> */}
          <Grid item xs={12}>
            <Card.Health360
              opened={health360Opened}
              toggle={() => setHealth360Opened(!health360Opened)}
              selectedHealth360s={selectedHealth360s}
              updateSelectedHealth360s={(health360s: IAppointment[]) =>
                setSelectedHealth360s(health360s)
              }
            />
          </Grid>
          <Grid item xs={12}>
            <Card.QarePlan
              opened={qarePlpanOpened}
              toggle={() => setQarePlanOpened(!qarePlpanOpened)}
            />
          </Grid>
          <Grid item xs={12}>
            <Card.Patient
              onClose={handleCreateReminderClose}
              opened={patientOpened}
              toggle={() => setPatientOpened(!patientOpened)}
            />
          </Grid>
        </Grid>
      </div>
    </>
  );
};
